import {combineReducers} from 'redux';
import welcome from './welcome.reducer';

const welcomeReducer = combineReducers({
    welcome
});

export default welcomeReducer;